import Tippy from '@tippyjs/react';

import { handleAction } from 'components/practice/charts/ClinicalNote/Orders/lib/handleActionMethods';
import Button from 'components/shared/Buttons/Button';

const Footer = ({
  handleClose,
  activeView,
  isELabOrder,
  handleActionProps,
  fromPatient,
  orderLoading = false
}) => {
  return (
    <div className="flex w-full items-center justify-between">
      <Button outlined color="neutral" text="Close" onClick={handleClose} data-qa="close-btn" />
      {activeView.component === 'create' && !fromPatient && (
        <div className="flex gap-1.5">
          <Button
            data-qa="save-btn"
            loadingIcon={activeView?.loading}
            disabled={activeView?.loading || fromPatient}
            text={isELabOrder ? 'Place Order' : 'Save'}
            onClick={() => handleAction({ ...handleActionProps, method: 'save' })}
          />
        </div>
      )}
      {activeView.component === 'preview' && !activeView.type === 'results' && !fromPatient && (
        <Tippy
          className="tippy-dark"
          disabled={!isELabOrder}
          content={
            isELabOrder
              ? 'Electronic Labs cannot be edited. Please contact lab directly to modify.'
              : ''
          }>
          <div className="flex gap-1.5">
            <Button
              data-qa="edit-btn"
              text="Edit"
              disabled={isELabOrder || orderLoading}
              onClick={() => handleAction({ ...handleActionProps, method: 'edit' })}
            />
          </div>
        </Tippy>
      )}
    </div>
  );
};

export default Footer;
